export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8461.2d8ebe44.jpg";